import { render, staticRenderFns } from "./CorrectiveActionTableList.vue?vue&type=template&id=f44a6b6a"
import script from "./CorrectiveActionTableList.vue?vue&type=script&lang=js"
export * from "./CorrectiveActionTableList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports